import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { SettingService } from '../api/setting.service';

@Injectable()
export class FilterService {

  constructor(
    private apiService: ApiService,
    private settingService: SettingService
  ) {
    this.apiService.init();
  }

  getFilterOptions(filterFor: string, filterContexts: string, filterClause?: string): Observable<any[]> {
    let request: Observable<any>;
    if (filterFor === 'ServiceOrder') {
      request = this.apiService.client.serviceOrders.options.GET(filterContexts);
    } else if (filterFor === 'ServiceNoteRequest') {
      request = this.apiService.client.serviceNoteRequests.options.GET(filterContexts, filterClause);
    } else {
      request = this.apiService.client.ucs.options.GET(filterContexts, filterClause);
    }
    return request.map((res) => {
      return this.apiService.handleResponse(res).results;
    }).switchMap(properties => {
      return this.settingService.getPropertyTranslations2(properties, 'displayName', 'displayName');
    });
  }

  getPropertyValues(filter): Observable<any[]> {
    if (filter.context.indexOf('Service Order Property') >= 0 || filter.context.indexOf('SO Selection') >= 0) {
      return this.getSoPropertyValues(filter.property_id);
    } else if (filter.context.indexOf('Backoffice') >= 0 ) {
      return this.getSnrPropertyValues(filter.property_id);
    } else if (filter.context) {
      return this.getUcPropertyValues(filter.property_id);
    }
    return Observable.of([]);
  }

  getUcPropertyValues(propertyId: number, filter?: string): Observable<any[]> {
    return this.apiService.client.properties.uc.propertyId(propertyId.toString()).values.GET(undefined, filter)
      .map((res) => {
        return this.apiService.handleResponse(res).results;
      });
  }

  getSoPropertyValues(propertyId: number): Observable<any[]> {
    return this.apiService.client.properties.so.propertyId(propertyId.toString()).values.GET()
      .map((res) => {
        return this.apiService.handleResponse(res).results;
      });
  }

  getSnrPropertyValues(propertyId: number): Observable<any[]> {
    return this.apiService.client.properties.snr.propertyId(propertyId.toString()).values.GET()
      .map((res) => {
        return this.apiService.handleResponse(res).results;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/filter.service.ts